import React from "react";
import TourDetails from "./TourDetails";
import {Card,CardContent, Typography,Button,Stack,Link} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles';
import {createTheme} from '@mui/material/styles';

//import { ClassNames } from "@emotion/react";
const tbcTheme = createTheme({
    palette:{
        primary:{
            main:'#ee4024',
        },
    }});

export default function ScreenCard({data}) {
    
    const openInNewTab = (e,url) => {
        e.preventDefault();
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const [buttonURL,setButtonURL] = React.useState(null);
    const [emailAddress,setEmailAddress] = React.useState("");
    const [buttonDisabled,setButtonDisabled] = React.useState(true);
    const [showLink,setShowLink] = React.useState("none");
    


    let setURL = (tourDetailURL) => {
        if(tourDetailURL !== "" && tourDetailURL != null){
            setButtonURL(tourDetailURL);
            setButtonDisabled(false);
        }else{
            setButtonURL("");
            setButtonDisabled(true);
        }
    }
    let setEmail = (email) => {
        
        if(email !== "" && email != null){
            
            setEmailAddress(email);
            setShowLink("block");
        }else{
            
            setEmailAddress("");
            setShowLink("none");
        }
    }    
    data.DateRangeDescription = data.HideDates ? data.ToBeAnnouncedMessage : data.DateRangeDescription;
    if (data == null) return null;
    
    return (

            <Card className="wtCard">
                <CardContent className="wtCardContent">
                    <Typography className="dateRangeDesc" variant="body1" color="text.secondary">{data.DateRangeDescription}</Typography>
                    <Typography className="wtTitle" gutterBottom variant="h4" component="div">{data.City}</Typography>
                    <TourDetails region={data.Region} setParentEmailLink={setEmail}setParentURL={setURL} data={data.TourDetails}/>
                    
                </CardContent>
                <ThemeProvider theme={tbcTheme}>
                    <Stack className="cta" direction="row" spacing="2"><Button  href={buttonURL} variant="contained" className="ctaButton" disabled={buttonDisabled} onClick={e => openInNewTab(e,buttonURL)}>Info</Button><Link  className="ctaLink" style={{display: showLink}} href={emailAddress}>Email</Link></Stack>
                </ThemeProvider>
            </Card>
     
    );
}